import PropTypes from 'prop-types';
import { useEffect, useMemo } from 'react';
import rtlPlugin from 'stylis-plugin-rtl';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { useTheme } from '@mui/material/styles';

// ----------------------------------------------------------------------

RtlLayout.propTypes = {
  children: PropTypes.node
};

export default function RtlLayout({ children }) {
  const theme = useTheme();

  useEffect(() => {
    document.dir = theme.direction;
  }, [theme.direction]);

  const cache = useMemo(() => {
    const c = createCache({
      key: theme.direction === 'rtl' ? 'rtl' : 'css',
      prepend: true,
      stylisPlugins: theme.direction === 'rtl' ? [rtlPlugin] : []
    });
    c.compat = true;
    return c;
  }, [theme.direction]);

  return (
    <CacheProvider value={cache}>{children}</CacheProvider>
  );
}
